<div class="container my-3 p-3 General container-fluid">
  <h3>Webinars & Presentations</h3>
  <app-videos-grid class="Videos" [videos]="returnVideoPage"></app-videos-grid>
  <div class="w-100">
    <div style="display: flex; justify-content: flex-end; margin-right: 2em; margin-top: 10px">
      <pagination [boundaryLinks]="showBoundaryLinks"
                  [directionLinks]="showDirectionLinks"
                  [totalItems]="videos.length"
                  [itemsPerPage]="6"
                  (pageChanged)="pageChanged($event)" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
                  lastText="&raquo;"></pagination>
    </div>

  </div>
</div>
